var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.556 22.8327V26.9994C29.5576 27.3862 29.4783 27.7691 29.3234 28.1235C29.1684 28.4779 28.9411 28.796 28.6561 29.0575C28.3711 29.319 28.0346 29.5181 27.6681 29.642C27.3017 29.7659 26.9134 29.812 26.5282 29.7772C22.2544 29.3128 18.149 27.8524 14.5421 25.5133C11.1863 23.3809 8.34117 20.5357 6.20876 17.1799C3.8615 13.5566 2.40076 9.43131 1.94487 5.13826C1.91016 4.75419 1.9558 4.3671 2.0789 4.00163C2.20199 3.63616 2.39983 3.30033 2.65982 3.01552C2.91981 2.7307 3.23626 2.50314 3.58902 2.34732C3.94178 2.19151 4.32312 2.11085 4.70876 2.11049H8.87542C9.54946 2.10385 10.2029 2.34254 10.714 2.78206C11.2251 3.22158 11.5589 3.83194 11.6532 4.49938C11.8291 5.8328 12.1552 7.14205 12.6254 8.40215C12.8123 8.89927 12.8527 9.43953 12.742 9.95893C12.6312 10.4783 12.3738 10.9551 12.0004 11.3327L10.2365 13.0966C12.2137 16.5737 15.0927 19.4528 18.5699 21.4299L20.3338 19.666C20.7114 19.2926 21.1881 19.0353 21.7075 18.9245C22.2269 18.8137 22.7672 18.8542 23.2643 19.041C24.5244 19.5113 25.8337 19.8374 27.1671 20.0133C27.8418 20.1084 28.4579 20.4483 28.8984 20.9681C29.3388 21.488 29.5729 22.1516 29.556 22.8327Z",
    stroke: "#199713",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIntIcon);
export default __webpack_public_path__ + "static/media/phone_int_icon.1fdf0229a49286e57e591b05f17ccf5f.svg";
export { ForwardRef as ReactComponent };